/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventStateImportRequestResponseDto
 */
export interface EventStateImportRequestResponseDto {
    /**
     * Unique identifier of the import request
     * @type {string}
     * @memberof EventStateImportRequestResponseDto
     */
    id: string;
    /**
     * Stored file path of the uploaded CSV used for the import
     * @type {string}
     * @memberof EventStateImportRequestResponseDto
     */
    filePath: string;
    /**
     * Import request execution status
     * @type {string}
     * @memberof EventStateImportRequestResponseDto
     */
    importStatus: EventStateImportRequestResponseDtoImportStatusEnum;
    /**
     * Timestamp when the import reached its latest known state. Null while unavailable.
     * @type {Date}
     * @memberof EventStateImportRequestResponseDto
     */
    importedAt: Date | null;
    /**
     * Timestamp when the import request was created
     * @type {Date}
     * @memberof EventStateImportRequestResponseDto
     */
    createdAt: Date;
    /**
     * Last error report captured for the import request
     * @type {object}
     * @memberof EventStateImportRequestResponseDto
     */
    errorReport: object | null;
}


/**
 * @export
 */
export const EventStateImportRequestResponseDtoImportStatusEnum = {
    InProgress: 'IN_PROGRESS',
    Succeeded: 'SUCCEEDED',
    Failed: 'FAILED'
} as const;
export type EventStateImportRequestResponseDtoImportStatusEnum = typeof EventStateImportRequestResponseDtoImportStatusEnum[keyof typeof EventStateImportRequestResponseDtoImportStatusEnum];


/**
 * Check if a given object implements the EventStateImportRequestResponseDto interface.
 */
export function instanceOfEventStateImportRequestResponseDto(value: object): value is EventStateImportRequestResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('filePath' in value) || value['filePath'] === undefined) return false;
    if (!('importStatus' in value) || value['importStatus'] === undefined) return false;
    if (!('importedAt' in value) || value['importedAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('errorReport' in value) || value['errorReport'] === undefined) return false;
    return true;
}

export function EventStateImportRequestResponseDtoFromJSON(json: any): EventStateImportRequestResponseDto {
    return EventStateImportRequestResponseDtoFromJSONTyped(json, false);
}

export function EventStateImportRequestResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventStateImportRequestResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'filePath': json['filePath'],
        'importStatus': json['importStatus'],
        'importedAt': (json['importedAt'] == null ? null : new Date(json['importedAt'])),
        'createdAt': (new Date(json['createdAt'])),
        'errorReport': json['errorReport'],
    };
}

export function EventStateImportRequestResponseDtoToJSON(json: any): EventStateImportRequestResponseDto {
    return EventStateImportRequestResponseDtoToJSONTyped(json, false);
}

export function EventStateImportRequestResponseDtoToJSONTyped(value?: EventStateImportRequestResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'filePath': value['filePath'],
        'importStatus': value['importStatus'],
        'importedAt': value['importedAt'] == null ? value['importedAt'] : value['importedAt'].toISOString(),
        'createdAt': value['createdAt'].toISOString(),
        'errorReport': value['errorReport'],
    };
}

